<template>
  <div class="c-personal-wrapper">
    <!-- filter -->
    <planner-filter ref="filterForm" @on-custom="customColumnModal = true" @on-down="exportTableData" @on-change="filterData">
      <ElButton slot="sync" v-if="authAsynBtn" :loading="asyning" @click="refreshData">同步数据</ElButton>
    </planner-filter>

    <!-- table  -->
    <div v-loading="loading" style="min-height: 300px">
      <Viewport v-model="tableHeight" v-if="tableLoaded">
        <el-table
          border
          class="common-el-table-styles summary-el-table-styles"
          :data="tableData"
          :height="tableHeight"
          :summary-method="summaries"
          show-summary
          @header-dragend="headerDragend"
          ref="plannerDataTable"
        >
          <el-table-column
            v-for="(col, id) in tableCol"
            :key="id"
            :prop="col.key"
            :label="col.title"
            :fixed="col.fixed"
            :show-overflow-tooltip="col.overflow"
            :min-width="col.width"
            :align="col.align"
          >
            <template slot-scope="{ row }">
              <span v-if="col.key.indexOf('Rate') > -1">{{ row[col.key] | toPercent }}</span>
              <span v-else-if="!['designerName', 'projectGroupName', 'totalAmount30'].includes(col.key)">
                {{ row[col.key] | toThousands }}
              </span>
              <span v-else>{{ row[col.key] }}</span>
            </template>
          </el-table-column>
        </el-table>
        <Page
          show-total
          show-sizer
          show-elevator
          class="c-table-page pager"
          size="small"
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
        />
      </Viewport>
    </div>

    <!-- 自定义列 -->
    <custom-column
      ref="tableCustomColsRef"
      v-model="customColumnModal"
      name="PlannerDataCustomColumn"
      :data="rawTableCols"
      :sub-title="['基础信息']"
      @on-select="onTableColsChange"
    />
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
import { toThousands, toPercentFixed } from '@/common/js/filters'
import { HOST_API } from '@/api/config'
import tableMixin from '../designerkpi/mixin_table'
import { plannerColumns } from '../data/planner_columns'
import PlannerFilter from './components/planner-filter'
import CustomColumn from '@/components/converter/custom-column2.vue'

import { getPlannerPage, asynPlannerPage } from '@/api/team.model'

export default {
  name: 'Planner',
  mixins: [tableMixin],
  components: { CustomColumn, PlannerFilter },
  computed: {
    access() {
      return this.$store.state.accessAuth
    },
    authAsynBtn() {
      return isArray(this.access) && this.access.includes('M20758')
    },
    tableCol() {
      return this.tableColumns.filter((ret) => ret.checked)
    }
  },
  data() {
    return {
      loading: null,
      asyning: null,
      customColumnModal: false,
      tableLoaded: false,
      tableHeight: 330,
      tableData: [],
      rawTableCols: plannerColumns,
      tableColumns: [],
      sumdata: [] // 合计数据
    }
  },
  methods: {
    refreshData() {
      this.asyning = true
      const { dateType, beginTime } = this.$refs.filterForm.buildParams()
      asynPlannerPage({ dateType, beginTime })
        .then((data) => {
          this.asyning = false
          data && this.getData()
        })
        .catch(() => {
          this.asyning = false
        })
    },
    exportTableData() {
      const { dateType, beginTime, projectGroupId, gameGroupId, gameId } = this.$refs.filterForm.buildParams()
      const exportsParams = new URLSearchParams({
        sessionid: this.$store.state.token,
        dateType,
        beginTime
      })

      if (projectGroupId > 0) exportsParams.append('projectGroupId', projectGroupId)
      if (gameGroupId > 0) exportsParams.append('gameGroupId', gameGroupId)
      if (gameId > 0) exportsParams.append('gameId', gameId)
      const url = `${HOST_API}/api/ptom/designer/materialDataExport?`
      window.open(url.concat(exportsParams.toString()))
    },
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumdata))
      const sums = []
      const twoDecimal = [
        'addVideoCount',
        'addImageCount',
        'amount',
        'amount7',
        'newAmount',
        'totalAmount30',
        'createRoleCost',
        'newRoleMoney',
        'oneLevelAmountCount',
        'twoLevelAmountCount',
        'threeLevelAmountCount',
        'fourLevelAmountCount',
        'oneLevelKpi',
        'twoLevelKpi',
        'threeLevelKpi'
      ]
      columns.forEach((column, index) => {
        const prop = column.property
        const val = parseFloat(data[prop])
        if (index === 0) {
          sums[index] = '合计'
          return
        }

        if (prop.indexOf('Rate') > -1) sums[index] = toPercentFixed(val)
        else if (twoDecimal.includes(prop)) sums[index] = toThousands(val)
      })
      return sums
    },
    getData() {
      const queryOpts = this.$refs.filterForm.buildParams()
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        ...queryOpts
      }
      this.loading = true
      getPlannerPage(params)
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            this.tableLoaded = true
            if (!data) return
            const { list, page_info, sum_data } = data
            if (isArray(list) && page_info && sum_data) {
              const { total_number } = page_info
              this.sumdata = sum_data
              this.tableData = list
              this.total = total_number || 0
            } else {
              this.tableData = []
              this.total = 0
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.tableLoaded = true
          this.tableData = []
          this.total = 0
        })
    },

    headerDragend(newWidth, oldWidth, column) {
      this.$refs.tableCustomColsRef.updateTableColWidth(newWidth, column)
    },
    onTableColsChange(cols) {
      this.tableColumns = cols
      this.customColumnModal = false
    }
  }
}
</script>
<style lang="scss" scoped>
.c-personal-wrapper {
  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
